/*
 * custom-macrons-product.js — ürün sayfası sihirbazı.
 * custom-macrons.js'ten fork: omslag adımı yok (ürün sleeve içerir),
 * her boyut gaveeske olduğu için postnummer her zaman sorulur,
 * step 2 ürünün standart makaronlarıyla önceden doldurulur.
 * Konfig: window.CMB_PRODUCT = { defaults: [navn...], trayUrl: '...' }
 */
$(document).ready(function() {

    var _prevBoxVariantId = '';
    var _summaryReached   = false;
    var _boxQty           = 1;
    var _minQtyGlobal     = parseInt($('#step1').attr('data-minqty')) || 0;
    var _currentStep      = 1;
    var _omslagEnabled    = false; // ürün sleeve içerir → Omslag adımı hiç gösterilmez
    var _postnummerOk     = false; // Oslo posta kodu doğrulandı mı
    var _pnPulseShown     = false; // "Sjekk postnummer" pulse vurgusu bu episode'da oynatıldı mı

    // TEST: Oslo aralığı 0120–0130 (canlıda gerçek liste ile değiştirilecek)
    function isOsloPostnummer(pn) {
        var n = parseInt(pn, 10);
        return n >= 120 && n <= 130;
    }

    // ── Tab state ─────────────────────────────────────────────────
    function setActiveTab(active) {
        $('.cmb-tab').each(function() {
            var s = parseInt($(this).data('step'));
            $(this).removeClass('cmb-tab--active cmb-tab--done');
            if (active > 6) {
                $(this).addClass('cmb-tab--done');
            } else if (s === active) {
                $(this).addClass('cmb-tab--active');
            } else if (s < active) {
                $(this).addClass('cmb-tab--done');
            } else {
                if (s === 6) {
                    if (_summaryReached) $(this).addClass('cmb-tab--done');
                } else {
                    var $sum = $('#step' + s + '-summary');
                    if ($sum.length && $.trim($sum.html()) !== '') {
                        $(this).addClass('cmb-tab--done');
                    }
                }
            }
        });
    }

    // ── Footer back button ────────────────────────────────────────
    var _backTargets = { 2: 1, 3: 2, 4: 3, 5: 4, 6: 5 };
    var _skipHistoryPush = false;
    // Omslag (adım 3) her zaman atlanır → 4. adımdan geri 2'ye döner
    function prevStepOf(n) {
        if (n === 4 && !_omslagEnabled) return 2;
        return _backTargets[n];
    }
    // Görünen tab numaralarını sıraya sok (data-step değişmez, sadece gösterilen rakam)
    function renumberTabs() {
        var n = 0;
        $('.cmb-tab').each(function () {
            if (!_omslagEnabled && parseInt($(this).data('step')) === 3) return;
            n++;
            $(this).find('.cmb-tab-num').text(n);
        });
    }
    function setOmslagEnabled(on) {
        _omslagEnabled = !!on;
        var $tab = $('.cmb-tab[data-step="3"]');
        if (_omslagEnabled) { $tab.show().next('.cmb-tab-line').show(); }
        else { $tab.hide().next('.cmb-tab-line').hide(); }
        renumberTabs();
    }
    function updateFooterBackBtn(n) {
        var $btn = $('#cmb-footer-back-btn');
        var target = prevStepOf(n);
        if (window.innerWidth >= 641 && n > 1 && target !== undefined) {
            $btn.data('target', target).show();
        } else {
            $btn.hide();
        }
    }
    $(document).on('click', '#cmb-footer-back-btn', function() {
        window.editStep(parseInt($(this).data('target')));
    });

    // ── Show only one step ────────────────────────────────────────
    // #step1 buy box'ta yaşar ve hiç gizlenmez; adım 1 = aşağıdaki
    // sihirbaz içeriğini kapatıp buy box'a scroll etmek demektir.
    function showOnlyStep(n) {
        _currentStep = n;
        if (!_skipHistoryPush) history.pushState({ wizard: true }, '');
        $('#step2, #step3, #step4, #gift-message-div').hide();
        $('#gift-price-summary, #add-to-card-div').hide();
        if (n === 1) {
            ftrMacronsHide();
            $('#cmb-footer-bar').hide(); // adım 1'i CTA (#pmw-bygg-btn) sürer
            updateFooterBtn(1);
            var s1Top = $('#step1').offset().top;
            $('html, body').stop().animate({ scrollTop: Math.max(0, s1Top - 140) }, 300);
            return;
        }
        $('#cmb-tabs').addClass('pmw-tabs-visible'); // akış başladı → sekme çubuğu görünür (display:flex)
        $('#pmw-bygg-btn').text('Fortsett byggingen →'); // buy box CTA artık "kaldığın yere dön" görevi görür
        if (n === 6) {
            _summaryReached = true;
            $('#gift-price-summary').show();
            $('#add-to-card-div').show();
            updateFooterBackBtn(6);
            $('#cmb-footer-next-btn').hide();
            $('#cmb-footer-bar').show();
            renderMacronSummary();
        } else {
            if (n === 2) { $('#step2').show(); ftrMacronsShow(); updateFtrMacronStrip(); }
            else if (n === 4) $('#step4').show();
            else if (n === 5) $('#gift-message-div').show();
            if (n !== 2) ftrMacronsHide();
            $('#cmb-footer-next-btn').show();
            updateFooterBackBtn(n);
            updateFooterBtn(n);
            $('#cmb-footer-bar').show();
        }
        // Adım 2'de daha derin scroll: sekmeler sticky olarak üstte kalır,
        // makaron içeriği (öneri kartları + grid) doğrudan görünür.
        var scrollTarget;
        if (n === 2) {
            scrollTarget = $('#step2').offset().top - (window.innerWidth <= 640 ? 110 : 140);
        } else {
            scrollTarget = $('#cmb-tabs').offset().top - 90;
        }
        $('html, body').stop().animate({ scrollTop: Math.max(0, scrollTarget) }, 300);
    }

    // ── Footer: button label / state ──────────────────────────────
    function updateFooterBtn(step) {
        var $btn = $('#cmb-footer-next-btn');

        if (step === 1) {
            var $sel   = $('.step1-child.selected');
            var hasSel = $sel.length > 0;
            var qtyOk  = _minQtyGlobal === 0 || _boxQty >= _minQtyGlobal;
            var needsPost = hasSel && !_postnummerOk; // her boyut gaveeske: önce Oslo postnummer kontrolü
            var disabled = !hasSel || !qtyOk;
            // Footer gizli ama state'i CTA tetiklemesi için senkron tutulur
            $btn.text(needsPost ? 'Sjekk postnummer →' : 'Neste →').prop('disabled', disabled);
            var $cta = $('#pmw-bygg-btn');
            $cta.text(needsPost ? 'Sjekk postnummer →' : 'Bygg esken →').prop('disabled', disabled);
            // CTA "Sjekk postnummer" durumuna ilk geçtiğinde tek seferlik pulse
            if (needsPost && hasSel && qtyOk) {
                if (!_pnPulseShown && $cta.length) {
                    _pnPulseShown = true;
                    $cta.removeClass('cmb-btn-pulse');
                    void $cta[0].offsetWidth; // reflow → animasyonu garanti başlat
                    $cta.addClass('cmb-btn-pulse');
                }
            } else {
                _pnPulseShown = false;
                $cta.removeClass('cmb-btn-pulse');
            }

        } else if (step === 2) {
            var tQty = parseInt($('.step2-c').attr('data-totalqty')) || 0;
            var max  = parseInt($('#step1').attr('data-productbundlespace')) || 0;
            $btn.prop('disabled', tQty < max);
            $btn.text('Neste →');

        } else if (step === 4) {
            var hasCard = $('.greeting-card.selected-card-box').length > 0;
            $btn.prop('disabled', false);
            if (hasCard) {
                $btn.text('Neste →');
            } else {
                $btn.text('Fortsett uten kort');
            }

        } else if (step === 5) {
            var hasMsg = $.trim($('#gift-message').val()) !== '';
            $btn.prop('disabled', false);
            $btn.text(hasMsg ? ('Bekreft og fullfør') : 'Fortsett uten melding');
        }
    }

    // ── Step summary builders (state tracking — hidden via CSS) ───
    function showStep1Summary() {
        var img   = $('.step1-child.selected').attr('data-image') || '';
        var title = $('#step1').attr('data-bundleproducttitle') || '';
        var price = $('#step1').attr('data-bundleproductprice') || '';
        $('#step1-summary').html(
            '<div class="cmb-sum-inner"><span class="cmb-sum-num">1</span>'
            + (img ? '<div class="cmb-sum-media"><img class="cmb-sum-img" src="' + img + '" alt=""></div>' : '')
            + '<div class="cmb-sum-text"><p class="cmb-sum-title">' + title + '</p><p class="cmb-sum-price">' + price + ',-</p></div>'
            + '</div>'
        );
    }
    function showStep2Summary() {
        var imgs = [];
        $('.macron-temp-div img').each(function() { if (imgs.length < 10) imgs.push($(this).attr('src')); });
        var count = parseInt($('.step2-c').attr('data-totalqty')) || 0;
        $('#step2-summary').html(
            '<div class="cmb-sum-inner"><span class="cmb-sum-num">2</span>'
            + '<div class="cmb-sum-macrons">' + imgs.map(function(s) { return '<img class="cmb-sum-macron" src="' + s + '" alt="">'; }).join('') + '</div>'
            + '<div class="cmb-sum-text"><p class="cmb-sum-title">' + count + ' makroner valgt</p></div>'
            + '</div>'
        );
    }
    function showStep3Summary(title, img) {
        $('#step3-summary').html(
            '<div class="cmb-sum-inner"><span class="cmb-sum-num">3</span>'
            + (img ? '<div class="cmb-sum-media"><img class="cmb-sum-img" src="' + img + '" alt=""></div>' : '')
            + '<div class="cmb-sum-text"><p class="cmb-sum-title">' + title + '</p></div>'
            + '</div>'
        );
    }
    function showStep4Summary(title, img) {
        $('#step4-summary').html(
            '<div class="cmb-sum-inner"><span class="cmb-sum-num">4</span>'
            + (img ? '<div class="cmb-sum-media"><img class="cmb-sum-img" src="' + img + '" alt=""></div>' : '')
            + '<div class="cmb-sum-text"><p class="cmb-sum-title">' + title + '</p></div>'
            + '</div>'
        );
    }
    function showStep5Summary(title) {
        $('#step5-summary').html(
            '<div class="cmb-sum-inner"><span class="cmb-sum-num">5</span>'
            + '<div class="cmb-sum-text"><p class="cmb-sum-title">' + title + '</p></div>'
            + '</div>'
        );
    }
    function resetSummariesFrom(step) {
        for (var i = step; i <= 5; i++) $('#step' + i + '-summary').html('');
        if (step <= 2) _summaryReached = false;
    }

    // ── Tab click: navigate to a completed step ───────────────────
    $(document).on('click', '.cmb-tab', function() {
        if (!$(this).hasClass('cmb-tab--done')) return;
        window.editStep(parseInt($(this).data('step')));
    });

    // ── Back button ───────────────────────────────────────────────
    $(document).on('click', '.cmb-back-btn', function() {
        var t = parseInt($(this).data('target'));
        if (t === 3 && !_omslagEnabled) t = 2; // Omslag yok → 2'ye dön
        window.editStep(t);
    });

    // ── Edit step ─────────────────────────────────────────────────
    window.editStep = function(n) {
        if (n === 1) {
            _prevBoxVariantId = $('#step1').attr('data-bundleproductvariantid') || '';
            $('#step1-next-btn').text('Neste →');
            setActiveTab(1);
            showOnlyStep(1);

        } else if (n === 2) {
            $('.full-basket').hide();
            $('.step2-main1').css('pointer-events', 'unset');
            $('.step2-main21').css('pointer-events', 'unset');
            $('.step2-child .macron-qty-main').css('display', 'flex');
            $('.cross-icon-div').show();
            setActiveTab(2);
            showOnlyStep(2);

        } else if (n === 4) {
            setActiveTab(4);
            showOnlyStep(4);

        } else if (n === 5) {
            setActiveTab(5);
            showOnlyStep(5);

        } else if (n === 6) {
            setActiveTab(6);
            showOnlyStep(6);
        }
        price_calculate();
    };

    window.addEventListener('popstate', function(e) {
        if (_currentStep > 1) {
            _skipHistoryPush = true;
            window.editStep(prevStepOf(_currentStep) || (_currentStep - 1));
            _skipHistoryPush = false;
        }
    });

    // ── Step 1: box size (variant) selection ─────────────────────
    $(document).on('click', ".step1-child", function() {
        var $this = $(this);
        var alreadySelected = $this.hasClass('selected');

        if (alreadySelected) {
            $this.removeClass('selected');
            _boxQty = 0;
            $('#step1')
                .attr('data-bundleProductPrice', '0')
                .attr('data-bundleProductVariantId', '')
                .attr('data-bundleProductTitle', '')
                .attr('data-productbundlespace', '0');
            // Reset steps 2+
            $('.full-basket').hide();
            $('.step2-child .macron-qty-main').css('display', 'flex');
            $('.step2-c').attr('data-totalqty', '0');
            $(".macron-qty").each(function() { $(this).text(0); });
            $(".step2-child-selected").each(function() { $(this).addClass('choose-image').html(''); });
        $('.preset-card').removeClass('active');
            $(".cover_box_input, .greeting_card_input").prop('checked', false);
            $(".greeting-card").removeClass("selected-card-box");
            $('#gift-message').val('');
            resetSummariesFrom(2);
            $('#postnummer-gate').removeClass('open');
            _postnummerOk = false;
            // Akış ortasında deselect: açık adım içeriğini, sekmeleri ve footer'ı kapat
            $('#step2, #step3, #step4, #gift-message-div, #gift-price-summary, #add-to-card-div').hide();
            $('#cmb-tabs').removeClass('pmw-tabs-visible');
            $('#cmb-footer-bar').hide();
            setActiveTab(1);
            updateFooterBtn(1);
            price_calculate();
            return;
        }

        $(".step1-child").removeClass("selected");
        $this.addClass("selected");
        // Sekmeler postnummer doğrulanmadan görünmez; kod zaten onaylıysa
        // (akış içinde kutu değişimi) seçimle birlikte açılır.
        if (_postnummerOk) $('#cmb-tabs').addClass('pmw-tabs-visible');
        var newId = $this.attr("data-variantid") || '';
        $('#step1').attr('data-bundleProductPrice',     $this.attr("data-price"));
        $('#step1').attr('data-bundleProductVariantId', newId);
        $('#step1').attr('data-bundleProductTitle',     $this.attr("data-title"));
        $('#step1').attr('data-productbundlespace',     $this.attr('data-bundlespace'));
        if (_minQtyGlobal === 0) _boxQty = 1;

        // Kutu değişimi: buy box'taki kartlar akış sırasında da tıklanabilir
        // olduğundan, akış başladıysa adım 1 mantığını baştan tetikle —
        // footer-next reset + yeni slot sayısı + default doldurma + adım 2'yi yapar.
        var isChange    = _prevBoxVariantId && newId !== _prevBoxVariantId;
        var flowStarted = $('#cmb-tabs').hasClass('pmw-tabs-visible');
        if (isChange && flowStarted) {
            $(".cover_box_input, .greeting_card_input").prop('checked', false);
            $(".greeting-card").removeClass("selected-card-box");
            $('#gift-message').val('');
            setActiveTab(1);
            updateFooterBtn(1);
            price_calculate();
            $('#cmb-footer-next-btn').trigger('click');
            return;
        }
        updateFooterBtn(1);
        price_calculate();
    });

    // ── Oslo posta kodu kontrolü ──────────────────────────────────
    $(document).on('input', '#postnummer-input', function () {
        var v = $(this).val().replace(/\D/g, '').slice(0, 4);
        if (v !== $(this).val()) $(this).val(v);
        var $msg = $('#postnummer-msg');
        if (v.length < 4) {
            _postnummerOk = false;
            $msg.text('').attr('class', 'postnummer-msg');
            $('#postnummer-switch').hide();
        } else if (isOsloPostnummer(v)) {
            _postnummerOk = true;
            $msg.html('✓ Vi leverer gaveeske til deg<br><span class="pn-nowrap">tirsdag eller torsdag, kl. 16–21</span>').attr('class', 'postnummer-msg postnummer-msg--ok');
            $('#postnummer-switch').hide();
        } else {
            _postnummerOk = false;
            $msg.text('Gaveesker sender vi kun i Oslo-området. Hverdagsbrett kommer perfekt frem til deg.').attr('class', 'postnummer-msg postnummer-msg--no');
            $('#postnummer-switch').show();
        }
        $('#postnummer-continue').prop('disabled', !_postnummerOk);
        updateFooterBtn(1);
    });
    $(document).on('keydown', '#postnummer-input', function (e) {
        if (e.key === 'Enter' && _postnummerOk) $('#postnummer-continue').click();
    });
    // Oslo kodu geçerli → modal kapanır, makaron adımına geçer
    $(document).on('click', '#postnummer-continue', function () {
        if (!_postnummerOk) return;
        $('#postnummer-gate').removeClass('open');
        $('#cmb-footer-next-btn').trigger('click');
    });
    // Oslo dışı kod → hverdagsbrett (tray) ürün sayfasına yönlendir
    $(document).on('click', '#postnummer-switch', function () {
        var cfg = window.CMB_PRODUCT || {};
        window.location.href = cfg.trayUrl || '/pages/create-your-own-box';
    });
    // Modalı aç (footer "Sjekk postnummer" → tıklanınca) — temiz giriş durumu
    function openPostnummerGate() {
        _postnummerOk = false;
        $('#postnummer-input').val('');
        $('#postnummer-msg').text('').attr('class', 'postnummer-msg');
        $('#postnummer-switch').hide();
        $('#postnummer-continue').prop('disabled', true);
        $('#postnummer-gate').addClass('open');
        setTimeout(function () { $('#postnummer-input').focus(); }, 120);
    }
    // Kapat (X / dış tıklama): kutu seçimi korunur; footer "Sjekk postnummer" kalır
    function closePostnummerGate() {
        $('#postnummer-gate').removeClass('open');
        updateFooterBtn(1);
    }
    $(document).on('click', '#postnummer-close', function () { closePostnummerGate(); });
    $(document).on('click', '#postnummer-gate', function (e) {
        if (e.target === this) closePostnummerGate();
    });

    // ── "Vårt utvalg": ürünün standart makaronları ────────────────
    // Metafield'lardaki standart makaronlar step 2 sepetine eşit
    // dağıtılır (6'lık → 1'er, 12'lik → 2'şer, 18'lik → 3'er).
    // İsim eşleşmeyen lezzet boş bırakılır ve konsola uyarı yazılır.
    // Adım 2 boş başlar; bu fonksiyonu "Vårt utvalg" öneri kartı çağırır.
    function prefillDefaultMacrons() {
        var cfg   = window.CMB_PRODUCT || {};
        var names = cfg.defaults || [];
        if (!names.length) return;
        var spaces = parseInt($('#step1').attr('data-productbundlespace')) || 0;
        if (!spaces) return;
        var matched = [];
        names.forEach(function(name) {
            var target = $.trim(name).toLowerCase();
            // Önce tam eşleşme; yoksa ön-ek toleransı (ör. metafield "Pistasjo",
            // lezzet listesi "Pistasj") — iki isimden biri diğeriyle başlıyorsa kabul.
            var $exact = $(), $prefix = $();
            $('.step2-child').each(function() {
                var flavor = $.trim($(this).find('.macron-name').text()).toLowerCase();
                if (!flavor) return;
                if (flavor === target) { $exact = $exact.add(this); }
                else if (flavor.length >= 4 && target.length >= 4
                         && (flavor.indexOf(target) === 0 || target.indexOf(flavor) === 0)) {
                    $prefix = $prefix.add(this);
                }
            });
            var $match = ($exact.length ? $exact : $prefix).first();
            if ($match.length) matched.push($match);
            else console.warn('[méribel] Standardmakron ikke funnet i smakslisten:', name);
        });
        if (!matched.length) return;
        var per = Math.floor(spaces / matched.length);
        var rem = spaces - per * matched.length;
        matched.forEach(function($m, i) {
            var qty  = per + (i < rem ? 1 : 0);
            var $inc = $m.find('.macron-increment');
            for (var k = 0; k < qty; k++) $inc.trigger('click');
        });
    }

    // ── Step 2: öneri kartları (firmagave deseninden) ─────────────
    function resetStep2Basket() {
        $('.full-basket').hide();
        $('.step2-main1, .step2-main21').css('pointer-events', 'unset');
        $('.step2-child .macron-qty-main').css('display', 'flex');
        $('.cross-icon-div').show();
        $('.step2-c').attr('data-totalqty', '0');
        $(".macron-qty").each(function () { $(this).text(0); });
        $(".step2-child-selected").each(function () { $(this).addClass('choose-image').html(''); });
        $('.preset-card').removeClass('active');
    }

    function applyPreset(preset) {
        resetStep2Basket();

        var boxSize = parseInt($('#step1').attr('data-productbundlespace')) || 12;
        var $macrons = $('.step2-child');
        var totalMacrons = $macrons.length;
        if (totalMacrons === 0) { updateFooterBtn(2); price_calculate(); return; }

        if (preset === 'vart-utvalg') {
            prefillDefaultMacrons();
        } else {
            var picks = [];
            var slotCount, baseQty, rem, i;
            if (preset === 'popular') {
                slotCount = Math.min(4, totalMacrons);
                baseQty = Math.floor(boxSize / slotCount);
                rem = boxSize % slotCount;
                for (i = 0; i < slotCount; i++) picks.push({ idx: i, qty: baseQty + (i < rem ? 1 : 0) });
            } else if (preset === 'classic') {
                slotCount = Math.min(3, totalMacrons);
                baseQty = Math.floor(boxSize / slotCount);
                rem = boxSize % slotCount;
                for (i = 0; i < slotCount; i++) picks.push({ idx: i, qty: baseQty + (i < rem ? 1 : 0) });
            } else if (preset === 'adventure') {
                slotCount = Math.min(boxSize, totalMacrons);
                for (i = 0; i < slotCount; i++) picks.push({ idx: i, qty: 1 });
                var remaining = boxSize - slotCount;
                for (i = 0; i < remaining; i++) picks[i % slotCount].qty += 1;
            }
            picks.forEach(function (p) {
                var $inc = $macrons.eq(p.idx).find('.macron-increment');
                for (var j = 0; j < p.qty; j++) $inc.trigger('click');
            });
        }

        // Preset doldurduktan sonra kurv paneli ve silme ikonları aktif kalsın
        $('.step2-main21').css('pointer-events', 'auto');
        $('.cross-icon-div').show();
        $('.preset-card[data-preset="' + preset + '"]').addClass('active');
        updateFtrMacronStrip();
        updateFooterBtn(2);
        price_calculate();
    }

    $(document).on('click', '.preset-card', function () {
        applyPreset($(this).data('preset'));
    });

    // ── Footer next button (handles ALL steps) ────────────────────
    $('#cmb-footer-next-btn').on('click', function() {
        if ($(this).prop('disabled')) return;
        var step = parseInt($('.cmb-tab--active').data('step'));

        if (step === 1) {
            // kod henüz doğrulanmadıysa: ilerleme yerine postnummer modalını aç
            if ($('.step1-child.selected').length > 0 && !_postnummerOk) {
                openPostnummerGate();
                return;
            }
            var newVariantId  = $('.step1-child.selected').attr('data-variantid') || '';
            var boxChanged    = !_prevBoxVariantId || newVariantId !== _prevBoxVariantId;
            var step2HasState = $.trim($('#step2-summary').html()) !== '';
            $('#step1-summary').html('');
            showStep1Summary();
            _prevBoxVariantId = newVariantId;

            if (boxChanged || !step2HasState) {
                $(".macron-qty").each(function() { $(this).text(0); });
                $('.step2-c').attr('data-totalqty', '0');
                var spaces = parseInt($('#step1').attr('data-productbundlespace')) || 0;
                $(".step2-selected-c").html('');
                for (var i = 0; i < spaces; i++) {
                    $(".step2-selected-c").append('<div class="step2-child-selected choose-image" style="cursor:unset"></div>');
                }
                $('.full-basket').hide();
                $('.step2-main1').css('pointer-events', 'unset');
                $('.step2-main21').css('pointer-events', 'unset');
                $('.step2-child .macron-qty-main').css('display', 'flex');
                $('.cross-icon-div').show();
                resetSummariesFrom(2);
                $('.preset-card').removeClass('active');
            }
            setActiveTab(2);
            showOnlyStep(2);

        } else if (step === 2) {
            showStep2Summary();
            // Omslag yok — cover'ı "ingen" yap, doğrudan Kort'a (4) geç
            $('#no-thanks-cover').prop('checked', true).trigger('change');
            showStep3Summary('Ingen omslag', null);
            setActiveTab(4); showOnlyStep(4);

        } else if (step === 4) {
            var hasCard = $('.greeting-card.selected-card-box').length > 0;
            if (hasCard) {
                showStep4Summary($('.selected-card-box .step3-title').text() || 'Kort', $('.selected-card-box .card-img-d').attr('src') || null);
            } else {
                $('#no-thanks-card').prop('checked', true).trigger('change');
                showStep4Summary('Ingen kort', null);
            }
            setActiveTab(5); showOnlyStep(5);

        } else if (step === 5) {
            var hasMsg = $.trim($('#gift-message').val()) !== '';
            showStep5Summary(hasMsg ? 'Melding lagt til' : 'Ingen melding');
            setActiveTab(6);
            showOnlyStep(6);
        }
        price_calculate();
    });

    // ── Step 4: card selected ─────────────────────────────────────
    $(document).on('click', '.greeting-card', function(e) {
        if ($(e.target).is('.greeting_card_input')) return;
        var $radio = $(this).find('.greeting_card_input');
        if ($radio.is(':checked')) {
            $radio.prop('checked', false);
            $(this).removeClass('selected-card-box');
            updateFooterBtn(4);
            price_calculate();
            return false;
        }
    });
    $(".greeting_card_input").change(function() {
        $(".greeting-card").removeClass("selected-card-box");
        $(this).parents(".greeting-card").addClass("selected-card-box");
        updateFooterBtn(4);
        price_calculate();
    });

    // ── Reset basket (Start på nytt inside step 2) ────────────────
    $("#reset-btn").click(function() {
        resetStep2Basket();
        updateFooterBtn(2);
        price_calculate();
    });

    // ── Sammendrag: slett alle valg og begynn på nytt ────────────
    $('#cmb-reset-all-btn').on('click', function() {
        $('.full-basket').hide();
        $('.step2-main1').css('pointer-events', 'unset');
        $('.step2-main21').css('pointer-events', 'unset');
        $('.step2-child .macron-qty-main').css('display', 'flex');
        $('.cross-icon-div').show();
        $('#gift-message').val('');
        resetSummariesFrom(1);
        $(".cover_box_input").each(function() { $(this).prop('checked', false); });
        $(".macron-qty").each(function() { $(this).text(0); });
        $(".step2-child-selected").each(function() { $(this).addClass('choose-image').html(''); });
        $('.preset-card').removeClass('active');
        $('.step2-c').attr('data-totalqty', '0');
        $(".greeting_card_input").each(function() { $(this).prop('checked', false); });
        $(".step1-child").removeClass("selected");
        $('#cmb-tabs').removeClass('pmw-tabs-visible');
        _prevBoxVariantId = '';
        setActiveTab(1);
        showOnlyStep(1);
        price_calculate();
    });

    // ── Change box size (full reset to step 1) ────────────────────
    $("#change_box_size").click(function() {
        $('.full-basket').hide();
        $('.step2-main1').css('pointer-events', 'unset');
        $('.step2-main21').css('pointer-events', 'unset');
        $('.step2-child .macron-qty-main').css('display', 'flex');
        $('.cross-icon-div').show();
        $('#gift-message').val('');
        resetSummariesFrom(1);
        $(".cover_box_input").each(function() { $(this).prop('checked', false); });
        $(".macron-qty").each(function() { $(this).text(0); });
        $(".step2-child-selected").each(function() { $(this).addClass('choose-image').html(''); });
        $('.preset-card').removeClass('active');
        $('.step2-c').attr('data-totalqty', '0');
        $(".greeting_card_input").each(function() { $(this).prop('checked', false); });
        $(".step1-child").removeClass("selected");
        $('#cmb-tabs').removeClass('pmw-tabs-visible');
        _prevBoxVariantId = '';
        setActiveTab(1);
        showOnlyStep(1);
        price_calculate();
    });

    // ── Macaron decrement ─────────────────────────────────────────
    $(".macron-decrement").click(function() {
        var qty = parseInt($(this).next('.macron-qty').text());
        if (qty === 0) return;
        $('.preset-card').removeClass('active');
        $(this).next('.macron-qty').text(qty - 1);
        var total = parseInt($('.step2-c').attr('data-totalqty')) - 1;
        $('.step2-c').attr('data-totalqty', total);
        var id    = $(this).parents(".step2-child").attr('data-ids');
        $('.cross-icon[data-crossid="' + id + '"]').last().parents('.step2-child-selected').addClass('choose-image').html('');
        updateFtrMacronStrip();
        updateFooterBtn(2);
        price_calculate();
    });

    // ── Macaron increment ─────────────────────────────────────────
    $(document).on('click', ".macron-increment", function(e) {
        e.preventDefault();
        var qty   = parseInt($(this).prev('.macron-qty').text());
        var total = parseInt($('.step2-c').attr('data-totalqty'));
        var max   = parseInt($('#step1').attr('data-productbundlespace'));

        if (total < max) {
            $('.preset-card').removeClass('active'); // elle değişiklik → preset vurgusu kalkar
            $('.step2-c').attr('data-totalqty', total + 1);
            $(this).prev('.macron-qty').text(qty + 1);
            var $product   = $(this).closest('.step2-child');
            var mName      = $product.find('.macron-name').text();
            var $emptySlot = $('.step2-child-selected').filter(function() {
                return $(this).find('img').length === 0;
            }).first();
            if ($emptySlot.length > 0) {
                $emptySlot.removeClass("choose-image").html(
                    '<div class="macron-temp-div" data-macronname="' + mName + '">'
                    + '<img class="card-img-e" alt="" src="' + $product.data('image') + '">'
                    + '<div class="cross-icon-div"><p data-crossid="' + $product.attr('data-id') + '" class="cross-icon">×</p></div>'
                    + '<p class="basket-macron-name">' + mName + '</p>'
                    + '</div>'
                );
            }
        }
        updateFtrMacronStrip();
        updateFooterBtn(2);
        if (total + 1 === max && window.innerWidth <= 640) flashKurvBtn();
        price_calculate();
    });

    $(document).on('click', ".macron-qty", function(e) { e.preventDefault(); });

    // ── Cross icon (remove macron from basket) ────────────────────
    $(document).on('click', ".cross-icon", function() {
        $('.preset-card').removeClass('active');
        var id       = $(this).attr('data-crossid');
        var $cell    = $("[data-ids='" + id + "']");
        $cell.find('.macron-qty').text(parseInt($cell.find('.macron-qty').text()) - 1);
        var newTotal = parseInt($('.step2-c').attr('data-totalqty')) - 1;
        $('.step2-c').attr('data-totalqty', newTotal);
        $(this).parents('.step2-child-selected').addClass('choose-image');
        $(this).parents('.macron-temp-div').remove();
        var max = parseInt($('#step1').attr('data-productbundlespace')) || 0;
        if (newTotal < max) {
            $('.full-basket').hide();
            $('.step2-main1, .step2-main21').css('pointer-events', 'unset');
            $('.step2-child .macron-qty-main').css('display', 'flex');
            $('.cross-icon-div').show();
        }
        updateFtrMacronStrip();
        updateFooterBtn(2);
    });

    // ── Mobile: footer macaron strip (step 2) ────────────────────────
    function updateFades() {
        var el = document.getElementById('cmb-ftr-macron-strip');
        if (!el) return;
        var $wrap = $('#cmb-ftr-strip-wrap');
        $wrap.toggleClass('fade-left',  el.scrollLeft > 4);
        $wrap.toggleClass('fade-right', el.scrollLeft < el.scrollWidth - el.clientWidth - 4);
    }

    function updateFtrMacronStrip() {
        if (window.innerWidth > 640) return;
        var $strip = $('#cmb-ftr-macron-strip');
        var $count = $('#cmb-ftr-macron-count');
        var max    = parseInt($('#step1').attr('data-productbundlespace')) || 0;
        var total  = parseInt($('.step2-c').attr('data-totalqty')) || 0;
        $strip.empty();
        $('.macron-temp-div').each(function() {
            var src = $(this).find('img.card-img-e').attr('src') || '';
            if (src) $strip.append('<img class="ftr-macron-avatar" src="' + src + '" alt="">');
        });
        $count.text(total + ' / ' + max);
        setTimeout(updateFades, 30);
        if ($('#cmb-kurv-sheet').hasClass('open')) renderKurvSheet();
    }

    function ftrMacronsShow() {
        if (window.innerWidth <= 640) $('#cmb-footer-macrons').css('display', 'flex');
    }
    function ftrMacronsHide() { $('#cmb-footer-macrons').hide(); }

    // ── Bottom sheet: Din kurv ────────────────────────────────────────
    function renderKurvSheet() {
        var $content = $('#cmb-kurv-sheet-content');
        $content.empty();
        var total = parseInt($('.step2-c').attr('data-totalqty')) || 0;
        if (total === 0) {
            $content.html('<p class="kurv-sheet-empty">Ingen makroner valgt ennå.</p>');
            return;
        }
        var html = '<div class="kurv-sheet-grid">';
        $('.macron-temp-div').each(function() {
            var src     = $(this).find('img.card-img-e').attr('src') || '';
            var name    = $(this).data('macronname') || '';
            var crossId = $(this).find('.cross-icon').attr('data-crossid') || '';
            html += '<div class="kurv-sheet-item">'
                + '<div class="kurv-sheet-img-wrap">'
                + '<img src="' + src + '" alt="' + name + '">'
                + '<button type="button" class="kurv-sheet-remove" data-crossid="' + crossId + '">×</button>'
                + '</div>'
                + '<p class="kurv-sheet-name">' + name + '</p>'
                + '</div>';
        });
        html += '</div>';
        $content.html(html);
    }

    function openKurvSheet()  { renderKurvSheet(); $('#cmb-kurv-sheet-overlay, #cmb-kurv-sheet').addClass('open'); }
    function closeKurvSheet() {
        $('#cmb-kurv-sheet-overlay, #cmb-kurv-sheet').removeClass('open');
        setTimeout(function () { $('#cmb-kurv-sheet-content').empty(); }, 320);
    }

    $('#cmb-se-kurv-btn').on('click', openKurvSheet);
    $(document).on('click', '#cmb-ftr-strip-wrap', openKurvSheet);

    function flashKurvBtn() {
        var $btn = $('#cmb-se-kurv-btn');
        $btn.removeClass('kurv-btn--flash');
        void $btn[0].offsetWidth;
        $btn.addClass('kurv-btn--flash');
        setTimeout(function() { $btn.removeClass('kurv-btn--flash'); }, 3300);
    }
    $('#cmb-kurv-sheet-close, #cmb-kurv-sheet-overlay').on('click', closeKurvSheet);

    $(document).on('click', '.kurv-sheet-remove', function() {
        var crossId = $(this).data('crossid');
        $('.step2-child-selected .cross-icon[data-crossid="' + crossId + '"]').last().trigger('click');
    });

    // ── Gift message character counter ────────────────────────────
    $(document).on('keyup', '#gift-message', function() { price_calculate(); updateFooterBtn(5); });
    var giftMessage        = document.getElementById('gift-message');
    var remainingCharacters = document.getElementById('remaining-characters');
    giftMessage.addEventListener('input', function() {
        var max     = 200;
        var current = this.value.length;
        if (current > max) this.value = this.value.substring(0, max);
        remainingCharacters.textContent = (max - this.value.length) + ' tegn igjen';
    });

    // ── Incomplete step modal ─────────────────────────────────────
    var _incompleteStep = 0;
    $('#incomplete-step-overlay, #incomplete-step-go').on('click', function() {
        $('#incomplete-step-modal').fadeOut(200);
        if ($(this).is('#incomplete-step-go') && _incompleteStep) {
            window.editStep(_incompleteStep);
        }
    });

    // ── Add to cart ───────────────────────────────────────────────
    $(document).on('click', '#add_box_to_card', function() {
        var stepLabels = {
            1: 'Velg størrelse (steg 1)', 2: 'Velg makroner (steg 2)',
            3: 'Velg omslag (steg 3)', 4: 'Velg hilsenkort (steg 4)', 5: 'Legg til melding (steg 5)'
        };
        var incomplete = 0;
        for (var s = 1; s <= 5; s++) {
            if (!$('#step' + s + '-summary').length || $.trim($('#step' + s + '-summary').html()) === '') {
                incomplete = s; break;
            }
        }
        if (incomplete) {
            _incompleteStep = incomplete;
            $('#incomplete-step-msg').text(stepLabels[incomplete] + ' er ikke fullført. Gå tilbake og fullfør dette steget for å legge i kurven.');
            $('#incomplete-step-modal').fadeIn(200);
            return;
        }

        $(".container-c2").show();
        fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: items })
        })
        .then(function() {
            $(".container-c2").hide();
            if (window.CartDrawer && typeof window.CartDrawer.open === 'function') {
                window.CartDrawer.open();
            } else {
                window.location.href = '/cart';
            }
        })
        .catch(function(error) {
            $(".container-c2").hide();
            console.error('Error:', error);
        });
    });

    // ── Macaron info modal ────────────────────────────────────────
    $(document).on('click', '.card-img-e', function() {
        if ($(this).closest('.step2-child-selected').length > 0) return;
        var $t = $(this);
        $('.modal-macron-img').attr('src', $t.attr('data-image'));
        $('.modal-macron-text').text($t.attr('data-name'));
        $('.modal-macron-description').text($t.attr('data-description'));
        $('.ingredient-p').text($t.attr('data-ingredient'));
        $('.allergy-p').text($t.attr('data-allergy'));
        $('.overlay').css({ display: 'flex', opacity: 0 }).animate({ opacity: 1 }, 400);
    });

    $('.close-btn').click(function() { $('.overlay').fadeOut(); });

    $(document).on('click', '.accordion-header', function() {
        var $action = $(this).find('.data-action-c');
        $action.text($action.text() === '+' ? '-' : '+');
        $(this).next('.accordion-collapse').toggleClass('show');
        $(this).toggleClass('collapsed');
    });

    // ── Macaron summary grid ──────────────────────────────────────
    function renderMacronSummary() {
        var isMobile = window.innerWidth <= 640;
        var html = '';
        if (isMobile) {
            var counts = {}, imgs = {}, order = [];
            $('.macron-temp-div').each(function() {
                var name = $(this).data('macronname') || '';
                var src  = $(this).find('img').attr('src') || '';
                if (!name) return;
                if (!counts[name]) { counts[name] = 0; imgs[name] = src; order.push(name); }
                counts[name]++;
            });
            if (!order.length) { $('#macron-summary-section').hide(); return; }
            order.forEach(function(name) {
                html += '<div class="macron-sum-card">'
                      + '<div class="macron-sum-img-wrap">'
                      + '<img class="macron-sum-img" src="' + imgs[name] + '" alt="' + name + '">'
                      + (counts[name] > 1 ? '<span class="macron-sum-qty">×' + counts[name] + '</span>' : '')
                      + '</div>'
                      + '<p class="macron-sum-name">' + name + '</p>'
                      + '</div>';
            });
        } else {
            $('.macron-temp-div').each(function() {
                var name = $(this).data('macronname') || '';
                var src  = $(this).find('img').attr('src') || '';
                if (!name) return;
                html += '<div class="macron-sum-card">'
                      + '<div class="macron-sum-img-wrap">'
                      + '<img class="macron-sum-img" src="' + src + '" alt="' + name + '">'
                      + '</div>'
                      + '<p class="macron-sum-name">' + name + '</p>'
                      + '</div>';
            });
        }
        if (!html) { $('#macron-summary-section').hide(); return; }
        $('#macron-summary-grid').html(html);
        $('#macron-summary-section').show();
    }

    // ── Price calculation ─────────────────────────────────────────
    var items = [];

    function price_calculate() {
        items = [];
        var greeting_card_id     = '';
        var message              = '';
        var selected_bundle_id   = '';
        var resultArray          = [];

        var greeting_card_price = parseFloat($('.greeting_card_input[type="radio"]:checked').attr('data-price') || 0);
        var bundle_price        = parseFloat($('#step1').attr('data-bundleproductprice') || 0);
        var total_price         = (greeting_card_price + bundle_price) * _boxQty;

        var stripItems = [];
        var boxImg   = $('.step1-child.selected').attr('data-image') || '';
        var boxTitle = $('#step1').attr('data-bundleproducttitle') || '';
        if (boxTitle) stripItems.push({ img: boxImg, title: boxTitle, price: bundle_price });

        var cardVal = $('.greeting_card_input[type="radio"]:checked').val();
        if (cardVal && cardVal !== 'no') {
            stripItems.push({
                img:   $('.selected-card-box .card-img-d').attr('src') || '',
                title: $('.selected-card-box .step3-title').text() || 'Kort',
                price: greeting_card_price
            });
        }

        if ($.trim($('#gift-message').val()) !== '') {
            stripItems.push({ type: 'message', title: 'Melding', price: 'Gratis' });
        }

        var msgIconSvg = '<svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>';
        var stripHtml = '';
        stripItems.forEach(function(item, i) {
            if (i > 0) stripHtml += '<span class="summary-sep">+</span>';
            var mediaHtml = item.type === 'message'
                ? '<div class="summary-img-wrap summary-icon-wrap">' + msgIconSvg + '</div>'
                : (item.img ? '<div class="summary-img-wrap"><img class="summary-img" src="' + item.img + '" alt=""></div>' : '');
            var priceHtml = item.type === 'message'
                ? '<p class="summary-item-price summary-gratis">Gratis</p>'
                : '<p class="summary-item-price">' + item.price.toFixed(0) + ',-</p>';
            stripHtml += '<div class="summary-item">' + mediaHtml + '<p class="summary-item-title">' + item.title + '</p>' + priceHtml + '</div>';
        });
        if (stripItems.length) {
            stripHtml += '<div class="summary-eq-block">'
                + '<span class="summary-sep">=</span>'
                + '<div class="summary-total-block">'
                + '<p class="summary-total-label">Totalt</p>'
                + '<p class="summary-total-price">' + total_price.toFixed(0) + ' kr</p>'
                + '</div>'
                + '</div>';
        }
        $('#order-summary-strip').html(stripHtml);
        // Ürün her zaman gaveeske → Oslo bud teslimat notu hep görünür
        $('#summary-delivery-note').toggle(stripItems.length > 0);

        selected_bundle_id = $('#step1').attr('data-bundleproductvariantid');
        var macronNameCount = {};
        $('.macron-temp-div').each(function() {
            var name = $(this).data('macronname');
            macronNameCount[name] = (macronNameCount[name] || 0) + 1;
        });
        $.each(macronNameCount, function(name, count) { resultArray.push(count + ' x ' + name); });

        message = $('#gift-message').val();
        var properties = {};
        resultArray.forEach(function(el, i) { properties["Makron#" + (i + 1)] = el; });

        greeting_card_id = $('.greeting_card_input[type="radio"]:checked').val();
        var messageEl = document.getElementById('dynamic-message');
        if (messageEl) {
            messageEl.textContent = greeting_card_id === 'no'
                ? "Meldingen din vil bli skrevet på en etikett og lagt i boksen, helt gratis."
                : "Meldingen din vil bli skrevet på baksiden av kortet du har valgt.";
        }
        properties["Gift Message"] = message;
        greeting_card_id = $('.greeting_card_input[type="radio"]:checked').val();

        if (selected_bundle_id !== undefined && selected_bundle_id !== '') items.push({ id: selected_bundle_id, quantity: _boxQty, properties: properties });
        if (greeting_card_id !== undefined && greeting_card_id !== 'no') items.push({ id: greeting_card_id, quantity: _boxQty, properties: { 'Gift Message': message || '' } });
    }

    // ── CTA: "Bygg esken" (buy box'taki adım 1 sürücüsü) ──────────
    // Sadece adım 1'i ilerletir; akış başladıysa (aktif adım > 1)
    // "Neste" gibi davranmaz, kullanıcıyı kaldığı adıma geri götürür.
    $(document).on('click', '#pmw-bygg-btn', function() {
        if ($(this).prop('disabled')) return;
        var activeStep = parseInt($('.cmb-tab--active').data('step')) || 1;
        if (activeStep === 1) {
            $('#cmb-footer-next-btn').trigger('click');
        } else {
            window.editStep(activeStep);
        }
    });

    // ── Initialise ────────────────────────────────────────────────
    setOmslagEnabled(false); // Omslag sekmesini gizle, sekmeleri yeniden numarala

    // Adım 1'i ürünün sağ kolonuna, klasik düzende taşı:
    // başlık → açıklama → boyut kartları + CTA → Klarna vb.
    // (Event'ler document'a delege — taşıma handler bozmaz.)
    var $buybox = $('.product__details--product-page').first();
    if ($buybox.length) {
        var $descBlock = $buybox.find('.product-block--description').first();
        if ($descBlock.length) $('#step1').insertAfter($descBlock);
        else $('#step1').appendTo($buybox);

        // Klarna satırını "Leverings- og friskhetspolicy" linkinin yanına taşı
        var $popup = $buybox.find('.product-popup').first();
        if ($popup.length && $('.pmw-klarna').length) $('.pmw-klarna').appendTo($popup);
    }

    // Üründe standart makaron tanımlı değilse "Vårt utvalg" kartını gizle
    if (!((window.CMB_PRODUCT || {}).defaults || []).length) {
        $('.preset-card[data-preset="vart-utvalg"]').hide();
    }

    var _stripEl = document.getElementById('cmb-ftr-macron-strip');
    if (_stripEl) _stripEl.addEventListener('scroll', updateFades, { passive: true });
    updateFooterBtn(1);
    history.replaceState({ wizardBase: true }, '');

});
